module.exports = __webpack_public_path__ + "static/media/coinbase.ce0bf60a.svg";